// src/utils/apiClient.js
const API_BASE =
  process.env.REACT_APP_API_URL ||
  (import.meta && import.meta.env && import.meta.env.VITE_API_BASE) ||
  "";

const USE_CAS = String(process.env.REACT_APP_USE_CAS || "false").toLowerCase() === "true";

export async function apiFetch(path, options = {}) {
  const url = path.startsWith("http") ? path : `${API_BASE}${path}`;

  const res = await fetch(url, {
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
    ...options,
  });

  if (res.status === 401) {
    // CAS path for prod, dev login page for local
    window.location.href = USE_CAS ? "/auth/login" : "/login";
    return;
  }

  const ct = res.headers.get("content-type");
  if (ct && ct.includes("application/json")) return res.json();
  return res;
}
